<template>
  <fragment>
    <v-data-table :height="`calc(100vh - ${isMobile ? '250px' : '132px'})`" class="main-table" :headers="headers"
      :items="reportToShow" sort-by="name" :search="search" item-key="_id" loading-text="Cargando" dense
      hide-default-footer no-data-text="No hay resultados" no-results-text="No hay resultados" disable-pagination
      fixed-header mobile-breakpoint="740"
      @click:row="!filterBy.isPop && !filterBy.isDep && $router.push(`/dashboard/planilla/payroll/${$event._id}`)">
      <template v-slot:top>
        <v-row class="px-3">
          <v-col cols="12" class="py-0" :sm="$vuetify.breakpoint.xsOnly ? 4 : 5">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
              hide-details></v-text-field>
          </v-col>
          <v-col cols="4" class="pt-xs-2 py-sm-0" sm="2">
            <date-filter @onSelectDate="onFilterDate($event)" :value="filterBy.date" :isMonthly="true" />
          </v-col>
          <v-col cols="4" class="pt-xs-2 py-sm-0" sm="2">
            <v-select :items="eras" label="Quincena" :value="filterBy.era" @change="onChangeEra($event)"></v-select>
          </v-col>
          <v-col cols="4" class="px-0 pt-sm-5 text-center" sm="3">
            <v-btn :loading="isFetching" :disabled="isFetching || !reports.length" color="primary" class="white--text"
              @click="downloadReport">
              <v-icon left dark>mdi-cloud-download</v-icon>Bajar
            </v-btn>
            <v-btn color="primary ml-3" :disabled="isFetching || !reports.length" class="white--text"
              @click="onPrintReports">
              <v-icon left dark>mdi-printer</v-icon>Constansias
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:header.name class="py-0">
        <span style="display: block; width: 160px">Nombre</span>
      </template>
      <template v-slot:body.append>
        <table-totals v-if="reports.length" :isDep="filterBy.isDep" :isPop="filterBy.isPop" :report="reportTotals"
          :isMobile="isMobile" />
      </template>
    </v-data-table>
    <router-view />
    <div class="print-container" ref="empReports" v-if="isPrint">
      <div class="report-container" v-for="emp in reportToShow" :key="emp._id">
        <emp-report class="dense" :emp="emp" :filterBy="filterBy" />
        <emp-report class="dense" :emp="emp" :filterBy="filterBy" :isCopy="true" />
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DateFilter from '../Misc/DateFilter'
import TableTotals from '../Misc/TableTotals'
import EmpReport from '@/components/EmpReport.vue';
import { formatMoney, printElement } from '@/services/utils.js'
import { tableHeader } from '@/services/constData.js'
export default {
  data() {
    return {
      search: '',
      eras: [
        { text: '1ra Quincena', value: 1 },
        { text: '2da Quincena', value: 2 }
      ],
      headers: [],
      isPrint: false
    }
  },
  created() {
    this.onSetReportType()
    this.formatMoney = formatMoney
  },
  methods: {
    ...mapActions('report', ['loadReports', 'downloadReport']),
    onPrintReports() {
      this.isPrint = true
      window.onafterprint = function () {
        console.log("Printing completed...");
      }
      this.$nextTick(() => {
        printElement(this.$refs.empReports)
        window.print()
      })
    },
    onFilterDate(dateStr) {
      const date = new Date(dateStr)
      const filterBy = { ...this.filterBy, date: date.valueOf() }
      this.$store.commit({ type: 'report/setFilter', filterBy })
      this.search = ''
      this.$router.push({ query: { ...this.$route.query, date: filterBy.date } })
    },
    onChangeEra(newEra) {
      const filterBy = { ...this.filterBy }
      filterBy.era = newEra
      this.$store.commit({ type: 'report/setFilter', filterBy })
      this.search = ''
      this.$router.push({ query: { ...this.$route.query, era: filterBy.era } })
    },
    onSetReportType() {
      const filterBy = { ...this.filterBy }
      const reportType = this.$route.query.type
      const { date, era } = this.$route.query
      if (date) filterBy.date = +date
      if (era) filterBy.era = +era
      var headers = tableHeader.payrollReport
      filterBy.isPop = false
      filterBy.isDep = false
      if (reportType === 'dep') {
        filterBy.isDep = true
        headers = tableHeader.depReport(this.filterBy.era, this.filterBy.date)
      } else if (reportType === 'pop') {
        filterBy.isPop = true
        headers = tableHeader.population
      }
      this.$store.commit({ type: 'report/setFilter', filterBy })
      this.headers = headers
      this.search = ''
      this.loadReports()
    }
  },
  computed: {
    ...mapGetters('report', ['reports', 'reportTotals', 'filterBy', 'isFetching']),
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600
    },
    reportToShow() {
      if (!this.reports.length) return []
      if (this.filterBy.isDep) {
        return this.reports.map(_dep => {
          const dep = { ..._dep }
          const era = this.filterBy.era
          dep.days.forEach((day, idx) => {
            dep['day' + (era === 1 ? idx + 1 : idx + 16)] = formatMoney(day)
          })
          dep.total = formatMoney(dep.total)
          return dep
        })
      }
      if (this.filterBy.isPop) return this.reports

      return this.reports.map(emp => ({
        ...emp,
        monthSalaryAyco: formatMoney(emp.monthSalaryAyco),
        monthSalaryNomina: formatMoney(emp.monthSalaryNomina),
        monthlySalaryAyco: formatMoney(emp.monthlySalaryAyco),
        monthlySalaryNomina: formatMoney(emp.monthlySalaryNomina),
        salaryAyco: formatMoney(emp.salaryAyco),
        salaryNomina: formatMoney(emp.salaryNomina),
        hourNomina: formatMoney(emp.hourNomina),
        hourAyco: formatMoney(emp.hourAyco),
        totalSalaryAyco: formatMoney(emp.totalSalaryAyco),
        totalSalaryNomina: formatMoney(emp.totalSalaryNomina),
        extraValueNomina: formatMoney(emp.extraValueNomina),
        extraValueAyco: formatMoney(emp.extraValueAyco),
        total: formatMoney(emp.total),
        totalDisc: formatMoney(emp.totalDisc),
        loan: formatMoney(emp.disc.loan ? emp.disc.loan.amount : 0),
        bonus: formatMoney(emp.disc.bonus ? emp.disc.bonus.amount : 0),
        shop: Object.entries(emp.shop).reduce((acc, entry) => {
          acc[entry[0]] = formatMoney(entry[1] ? entry[1].amount : 0)
          return acc
        }, {})
      }))
    },
  },
  components: {
    DateFilter,
    TableTotals,
    EmpReport
  },
  watch: {
    $route(to, from) {
      if (to.name === 'payrollDetail' || from.name === 'payrollDetail') return
      this.onSetReportType()
    }
  },
}
</script>
